import { SelectProps } from "antd";
import SelectBaseAntd from "../SelectBaseAntd";
import { TipoContabilizacaoEnum } from "features/exportacao-contabil/typings";
export interface SelectTipoContabilizacaoProps<T = any> extends SelectProps<T> {
  value: any;
  onChange: (v: any) => void;
  isInvalid?: boolean;
  tipo?: "cliente" | "fornecedor";
}

function SelectTipoContabilizacao({
  onChange,
  value,
  isInvalid,
  tipo = "cliente",
  ...rest
}: SelectTipoContabilizacaoProps) {
  const options =
    tipo === "cliente"
      ? [
          {
            label: "Provisão + Baixa por cliente",
            value: TipoContabilizacaoEnum.ProvisaoBaixaCliente,
          },
          {
            label: "Baixa por cliente",
            value: TipoContabilizacaoEnum.BaixaCliente,
          },
          {
            label: "Baixa sem previsão",
            value: TipoContabilizacaoEnum.BaixaPrevisao,
          },
        ]
      : [
          {
            label: "Provisão + Baixa por fornecedor",
            value: TipoContabilizacaoEnum.ProvisaoBaixaFornecedor,
          },
          {
            label: "Baixa por fornecedor",
            value: TipoContabilizacaoEnum.BaixaFornecedor,
          },
          {
            label: "Baixa sem previsão",
            value: TipoContabilizacaoEnum.BaixaPrevisao,
          },
        ];

  return (
    <SelectBaseAntd
      onChange={onChange}
      placeholder="Lançamento sem previsão"
      value={value}
      isInvalid={isInvalid}
      size="large"
      {...rest}
      options={options}
    />
  );
}

export default SelectTipoContabilizacao;
